/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useRef, useState, useEffect } from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import ArtistEditsInformation from "./ArtistEditsInformation.vue";
import { VueTeleport } from "common/vue/VueTeleport";

export default function PinningHeader({ isDesktop = false, ...restProps }) {
  const howItWorksButtonRef = useRef(null);
  const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);
  const [isDesktopPopoverVisible, setIsDesktopPopoverVisible] = useState(false);
  const [desktopPopoverStyle, setDesktopPopoverStyle] = useState({});
  const desktopPopoverEl = useRef(null);
  const popoverHideTimeoutRef = useRef(null);

  // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  useEffect(() => () => clearTimeout(popoverHideTimeoutRef.current), []);

  function showDesktopPopover() {
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    clearTimeout(popoverHideTimeoutRef.current);
    const $button = howItWorksButtonRef.current;
    if ($button) {
      // @ts-expect-error TS(2339): Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
      const rect = $button.getBoundingClientRect();
      const popoverWidth = 580;
      const gap = 8;
      const margin = 8;
      let left = rect.left - popoverWidth - gap;
      if (left < margin) {
        left = rect.right + gap;
      }
      left = Math.max(margin, Math.min(left, window.innerWidth - popoverWidth - margin));
      setDesktopPopoverStyle({
        left: `${left}px`,
        top: "0px",
        visibility: "hidden"
      });
      setIsDesktopPopoverVisible(true);
      queueMicrotask(() => {
        setIsDesktopPopoverVisible(visible => {
          if (!visible) return visible;
          const el = desktopPopoverEl.current;
          if (el) {
            // @ts-expect-error TS(2339): Property 'offsetHeight' does not exist on type 'ne... Remove this comment to see the full error message
            const popoverHeight = el.offsetHeight;
            const buttonCenterY = rect.top + rect.height / 2;
            const idealTop = buttonCenterY - popoverHeight / 2;
            const clampedTop = Math.max(
              margin,
              Math.min(idealTop, window.innerHeight - popoverHeight - margin)
            );
            setDesktopPopoverStyle({
              left: `${left}px`,
              top: `${clampedTop}px`
            });
          }
          return visible;
        });
      });
      return;
    }
    setIsDesktopPopoverVisible(true);
  }

  function hideDesktopPopover() {
    // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
    popoverHideTimeoutRef.current = setTimeout(() => {
      setIsDesktopPopoverVisible(false);
    }, 150);
  }

  function openHowItWorksModal() {
    if (isDesktop) {
      showDesktopPopover();
    } else {
      setIsHowItWorksOpen(true);
    }
  }

  function closeHowItWorks() {
    setIsHowItWorksOpen(false);
  }

  return (
    <div
      {...restProps}
      className={cn(
        "flex w-full shrink-0 flex-col bg-white p-4",
        !isDesktop && "shadow-sm",
        // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
        restProps.className
      )}
      data-testid="pinning-header"
    >
      <div className="flex items-center justify-between">
        <h2 className="m-0 text-lg font-semibold text-gray-800">Get Free AI Edits</h2>
        <div className="flex items-center gap-1">
          <UseSvg className="h-4 w-4 text-gray-500" icon="info-circle-bold" data-testid="h-4" />
          <button
            className="cursor-pointer border-0 bg-transparent p-0 text-sm !text-blue-700 underline"
            ref={howItWorksButtonRef}
            type="button"
            data-testid="how-it-works-button"
            onClick={openHowItWorksModal}
            onMouseEnter={() => {
              isDesktop && showDesktopPopover();
            }}
            onMouseLeave={() => {
              isDesktop && hideDesktopPopover();
            }}
          >
            {" "}
            How it works{" "}
          </button>
        </div>
      </div>
      <VueTeleport to="body" data-testid="teleport">
        {isDesktop && isDesktopPopoverVisible ? (
          <div
            className="fixed z-[2147483001] max-h-[90vh] w-[580px] overflow-y-auto rounded-lg border border-gray-200 bg-white p-4 text-sm shadow-lg"
            ref={desktopPopoverEl}
            style={desktopPopoverStyle}
            onMouseEnter={() => {
              showDesktopPopover();
            }}
            onMouseLeave={() => {
              hideDesktopPopover();
            }}
            data-testid="fixed"
          >
            <ArtistEditsInformation data-testid="artist-edits-information" />
          </div>
        ) : null}
      </VueTeleport>
      <VueTeleport to="body" data-testid="teleport-1">
        {!isDesktop && isHowItWorksOpen ? (
          <div className="fixed inset-0 z-[2147483001] flex items-center justify-center px-4">
            <div
              className="absolute inset-0 bg-black/60"
              onClick={closeHowItWorks}
              data-testid="absolute"
            />
            <div className="relative max-h-[95dvh] w-full overflow-y-auto rounded-lg bg-white px-2.5 py-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
              <ArtistEditsInformation
                isMobile={true}
                onClose={closeHowItWorks}
                data-testid="artist-edits-information-1"
              />
            </div>
          </div>
        ) : null}
      </VueTeleport>
    </div>
  );
}
